<div class="relative">
  @if (control()) {
    <input
      class="base-input-text w-full transition-shadow duration-[0.3s]"
      [attr.data-testid]="testId()"
      [class.input-text-input--password]="type() === 'password'"
      [class.input-text-input--error-colored]="
        control().errors | isErrorColored: invalidControl() : validationErrors()
      "
      [formControl]="control()"
      [imask]="mask() ? { mask: mask() } : { mask: false }"
      [type]="type() === 'password' ? passwordInputType : type()"
      [placeholder]="title()"
      [tabindex]="tabIndex()"
      (focus)="onFocus()"
      #inputElement
    />
  }
  @if (type() === 'password') {
    <div
      class="absolute right-[12px] top-[19px] cursor-pointer"
      tabindex="0"
      (keydown)="onPasswordToggleClick()"
      (click)="onPasswordToggleClick()"
    >
      @if (passwordInputType === 'password') {
        <svg class="fill-base-500 h-[24px] w-[24px]">
          <use xlink:href="#16px_eye-closed"></use>
        </svg>
      }
      @if (passwordInputType === 'text') {
        <svg class="fill-base-500 h-[24px] w-[24px]">
          <use xlink:href="#16px_eye-opened"></use>
        </svg>
      }
    </div>
  }
</div>

@if (control().errors | isErrorColored: invalidControl() : validationErrors()) {
  <shared-form-error
    [errors]="control().errors"
    [validationErrors]="validationErrors()"
  >
  </shared-form-error>
}
